import React from 'react'
import { useValue } from '@morningtrain/react-resources'
import { useShouldConditionallyRender } from '@morningtrain/react-helpers'

export default function ApplyClassNameWhenValue ({ name, matches, className, children }) {
  const value = useValue(name)

  const [hasMatch] = useShouldConditionallyRender(value, matches)

  function childProps (child) {
    let props = {}

    if (child && child.props) {
      props = { ...child.props, ...props }
    }

    if (hasMatch) {
      props.className = className
    }

    return props
  }

  return React.Children.map(children, child => React.cloneElement(child, childProps(child)))
}
